<script>
export default {
  inheritAttrs: false,
  model: {
    event: 'update',
  },
  props: {
    type: {
      type: String,
      default: 'password',
      validator(value) {
        return ['text', 'password'].includes(value)
      },
    },
    error: {
      type: String,
      default: '',
    },
    hideEye: {
      type: Boolean,
      default: false,
    },
    changed: {
      type: Boolean,
    },
    changedColor: {
      type: String,
      default: '#FFEDE1',
    },
  },
  data() {
    return {
      typeChanged: this.type,
      icon: 'eye-slash',
      showPassword: false,
    }
  },
  computed: {},
  methods: {
    handleType(event) {
      const { srcElement, type } = event
      const { value } = srcElement

      if (this.showPassword) {
        return
      }

      if (type === 'blur' && !value) {
        this.typeChanged = 'text'
      } else {
        this.typeChanged = 'password'
      }
    },

    togglePassword() {
      if (this.showPassword) {
        this.typeChanged = 'password'
        this.icon = 'eye-slash'
        this.showPassword = false
      } else {
        this.typeChanged = 'text'
        this.icon = 'eye'
        this.showPassword = true
      }
    },
  },
}
</script>

<template>
  <div class="position-relative">
    <input
      autocomplete="off"
      :type="typeChanged"
      :class="{ [$style.input]: true, [$style.error]: error }"
      v-bind="$attrs"
      :style="{ background: changed ? changedColor : '#fff' }"
      @input="$emit('update', $event.target.value)"
      v-on="$listeners"
      @focus="handleType"
      @blur="handleType" />
    <span v-if="!hideEye" @click="togglePassword">
      <BaseIcon :name="icon" :class="$style.iconInput" />
    </span>
    <div :class="$style.errorContainer">
      <p v-if="error" :class="$style.errorMessage" class="tag-text">{{ error }}</p>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.input {
  width: 100%;
  height: 40px;
  padding: 10px 40px 10px 24px;
  font-size: 16px;
  color: $primary-blue;
  border: 0.5px $primary-blue solid;
  border-radius: 36px;
  outline: none;

  &::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: $gray;
    opacity: 1;
  }

  &.error {
    color: $secondary-red;
    border: 0.5px $secondary-red solid;
  }
}

.errorContainer {
  position: absolute;
  right: 0;
  left: 0;

  .errorMessage {
    @extend %error-message;

    text-align: right;
  }
}

.iconInput {
  position: absolute;
  top: 12px;
  right: 18px;
  color: $primary-blue;
  cursor: pointer;
}
</style>
